module.exports = __webpack_public_path__ + "annualreview2017/static/img/low-carbon-readiness-2@0,5x.610955c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circles/focus/low-carbon-readiness-2@0,5x.jpg
// module id = 717
// module chunks = 0